import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';
import { ROUTES } from '@/constants';
import { hasAllPermissions } from '@/utils/accountPermissions';

/**
 * Like {@link RoleGuard} but uses the effective permission bitmask (same rules as API `checkPermission`).
 *
 * @param {React.ReactNode} children
 * @param {(import('@/constants/permissions').PERMISSIONS[keyof import('@/constants/permissions').PERMISSIONS]|number)[]} requiredPermissions
 * @param {string} [redirectTo]
 */
export function PermissionRedirectGuard({
    children,
    requiredPermissions = [],
    redirectTo = ROUTES.HOME,
}) {
    const { user } = useAuthContext();
    const mask = user?.permissions ?? 0;
    const allowed = hasAllPermissions(mask, ...requiredPermissions);

    if (!user || !allowed) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
}

export default PermissionRedirectGuard;
